import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { userImage } from '../../../core/helpers';
import { ApplicationRole, UserProfile } from '../../../core/models';
import { AccountService, AuthenticationService } from '../../../core/services';
import { CouponModalComponent } from '../../../shared/components/coupon-modal/coupon-modal.component';
import { DepositModalComponent } from '../../../shared/components/deposit-modal/deposit-modal.component';

@Component({
    selector: 'gs-sidebar',
    templateUrl: './sidebar.component.html',
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChild('menuTemplate') menuTemplateRef: TemplateRef<any>;

  readonly ApplicationRole = ApplicationRole;

  user: UserProfile;

  get userImageUrl(): string {
    return userImage(this.user?.image);
  }

  private subscriptions: Subscription[] = [];

  constructor(
    private accountService: AccountService,
    private authService: AuthenticationService,
    private store: Store,
    private modalService: NgbModal,
    private offcanvasService: NgbOffcanvas,
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.store.select<UserProfile>(state => state.auth.user)
        .subscribe(user => {
          this.user = user;
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  openMenu() {
    this.offcanvasService.open(this.menuTemplateRef, { panelClass: 'offcanvas-lg', position: 'start' });
  }

  onCoupon() {
    const modalRef = this.modalService.open(CouponModalComponent, { backdrop: 'static', });
    modalRef.componentInstance.title = 'Aplica un card cadou GiftShare';
  }

  onDepositClick() {
    const modalRef = this.modalService.open(DepositModalComponent, { backdrop: 'static', });
    modalRef.componentInstance.title = 'Adauga fonduri';
  }

  logout() {
    this.authService.logout();
  }
}
